module.exports = __webpack_public_path__ + "img/vnd.google-apps.spreadsheet.45dd8dda.svg";